export enum Period {
  HOUR = 'hour',
  DAY = 'day',
  WEEK = 'week',
  MONTH = 'month',
  YEAR = 'year',
}

export const periodNameMap: Record<Period, string> = {
  [Period.HOUR]: 'Saat',
  [Period.DAY]: 'Gün',
  [Period.WEEK]: 'Hafta',
  [Period.MONTH]: 'Ay',
  [Period.YEAR]: 'Yıl',
};

export const periodToDateFormatMap: Record<Period, string> = {
  [Period.HOUR]: 'd MMMM yyyy HH:mm',
  [Period.DAY]: 'd MMMM yyyy',
  [Period.WEEK]: 'd MMMM yyyy',
  [Period.MONTH]: 'MMMM yyyy',
  [Period.YEAR]: 'yyyy',
};
